import React from 'react'
import ReactDOM from 'react-dom/client'
import './styles/main.scss'
import { RouterProvider } from 'react-router-dom'
import { router } from './router'
import { initGoogleAnalytics } from './utils/analytics'

const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(
  <React.StrictMode>
    <RouterProvider router={router}></RouterProvider>
  </React.StrictMode>,
)

// Initialiser GA uniquement en production
if (process.env.REACT_APP_NODE_ENV === 'production') {
  initGoogleAnalytics()
}

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/sw.js')
      .then(
        (reg) =>
          process.env.REACT_APP_NODE_ENV === 'development' &&
          console.log('✅ Service Worker enregistré:', reg),
      )
      .catch(
        (err) =>
          process.env.REACT_APP_NODE_ENV === 'development' &&
          console.error('❌ Erreur Service Worker:', err),
      )
  })
}
